import React, { FC, useEffect, useState } from 'react';
import { useConnection } from '../../../connection/Application';
import { CandidateLayout, SEO_COMMON } from '../../../layout/candidate/CandidateLayout';
import { Title } from '../../../components/Typogrphy/Title';
import styles from '../HomePage.module.less';
import { Avatar, Image, Spin, Typography } from 'antd';
import Utils from '../../../utils/Utils';
import { NextSeo } from 'next-seo';

type Testimonial = {
  description: string;
  userImage?: string;
  companyImage?: string;
  company: string;
  name: string;
  designation: string;
};

export const TestimonialsPage: FC = () => {
  const { Text, Paragraph } = Typography;
  const [testimonials, setTestimonials] = useState<Testimonial[]>([]);
  const [loading, setLoading] = useState<boolean>(false);
  const connection = useConnection();
  useEffect(() => {
    setLoading(true);
    connection
      .get('testimonials')
      .then((v) => {
        setTestimonials(v);
      })
      .catch(() => console.log('Error getting Testimonials'))
      .finally(() => setLoading(false));
  }, [connection]);

  return (
    <CandidateLayout
      title={
        <NextSeo
          canonical={'https://www.careers360.lk/view-testimonials'}
          title={'Testimonials'}
          {...SEO_COMMON}
        />
      }>
      <div className={styles.testimonialsPage}>
        <div className={styles.testimonialTitle}>
          <Title level={1}>Testimonials</Title>
        </div>

        {/*{loading && (*/}
        {/*  <div>*/}
        {/*    <Spin  />*/}
        {/*  </div>*/}
        {/*)}*/}
        <Spin spinning={loading}>
          <div className={styles.testimonialContainer}>
            <div className={styles.testimonialGrid}>
              {testimonials.map((item) => {
                return (
                  <div
                    className={styles.maincontainer}
                    // style={{ position: 'relative' }}
                    key={item.name}>
                    <div>
                      <Avatar size={120} src={item.userImage ?? undefined} />
                    </div>
                    <div className={styles.text}>
                      <Paragraph className={'text-[20px]'}>{item.description}</Paragraph>
                    </div>
                    <div className={styles.bottomcontainer}>
                      <div className={styles.logoContainer}>
                        <div>
                          {item.companyImage && (
                            <Image
                              height={75}
                              width={75}
                              src={item.companyImage}
                              preview={false}
                              alt={`${item.company} logo`}
                            />
                          )}
                        </div>
                      </div>
                      <div>
                        <div className={styles.companyName}>
                          <Text className={'text-[18px]'}>{item.company}</Text>
                        </div>
                        <div className={styles.name}>
                          <Text className={'text-[28px]'}>{item.name}</Text>
                        </div>
                        <div
                          className={Utils.mergeClasses(
                            styles.testimonialJobTitle,
                            styles.jobTitle,
                          )}>
                          <Text className={'text-[15px]'}>{item.designation}</Text>
                        </div>
                      </div>
                    </div>
                  </div>
                );
              })}
            </div>
          </div>
        </Spin>
      </div>
    </CandidateLayout>
  );
};
